import * as React from 'react'

import Localization from '~/client/src/shared/localization/LocalizationManager'

export default function Header(): React.ReactElement {
  return (
    <header className="tw:flex tw:items-center tw:justify-between tw:gap-4 tw:px-4 tw:pb-4">
      <h1 className="tw:text-display-sm tw:m-0">
        {Localization.translator.workflows}
      </h1>
    </header>
  )
}
